const DRAWER_PLACEMENT = {
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left"
};
const DRAWER_SIZE = { SMALL: 400, MEDIUM: 768, LARGE: 1024 };
const DRAWER_DEFAULT_SIZE = "SMALL";
const DRAWER_OFFSET = 180;
const DRAWER_MOBILE_OFFSET = 60;
export {
  DRAWER_DEFAULT_SIZE,
  DRAWER_MOBILE_OFFSET,
  DRAWER_OFFSET,
  DRAWER_PLACEMENT,
  DRAWER_SIZE
};
//# sourceMappingURL=drawer.es.js.map
